import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

const ProtectedRoute = ({ requireRole }) => {
    const { isAuthenticated, isLoading, currentUser } = useAuth();
    const location = useLocation();

    if (isLoading) return null;
    if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
    if (requireRole && currentUser?.role !== requireRole) return <Navigate to="/" replace />;

    return <Outlet />;
};

export default ProtectedRoute;
